<template>
  <b-modal header-close-content="" id="general-options-modal" :title="$t('options')" ok-only>
    <b-tabs>
      <b-tab :title="$t('menubar.general')" class="p-2">
        <div>
          <b-form-checkbox v-model="settings.ShowConfirmationDialogOnDragAndDrop" inline>
            {{ $t("menubar.options.showConfirmationOnDragDrop") }}
          </b-form-checkbox>
        </div>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      checked: true,
      settings: {
        ShowConfirmationDialogOnDragAndDrop: true
      }
    };
  },
  computed: {
    ...mapState(["userSettings"])
  },
  methods: {
    ...mapActions(["saveUserSettings"])
  },
  watch: {
    settings: {
      deep: true,
      handler(nv) {
        this.saveUserSettings(nv);
      }
    },
    userSettings: {
      immediate: true,
      deep: true,
      handler(nv) {
        if (!nv) return;

        Object.assign(this.settings, {
          ShowConfirmationDialogOnDragAndDrop: nv.ShowConfirmationDialogOnDragAndDrop === true || nv.ShowConfirmationDialogOnDragAndDrop === "true"
        });
      }
    }
  }
};
</script>
